var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"policy bg-white"},[_c('div',{staticClass:"container mx-auto py-16"},[_c('div',{staticClass:"mt-6",domProps:{"innerHTML":_vm._s(_vm.$lang.get('landingpage.privacy-policy.text'))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }